module.exports = __webpack_public_path__ + "img/icon1.bf493793.svg";